
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".734","y":".5","width":"19","height":"19","rx":"9.5","fill":"#FF5050"}}),_c('path',{attrs:{"d":"M15.077 6.242a.767.767 0 00-1.085-1.084l-3.758 3.757-3.757-3.757a.767.767 0 10-1.085 1.084L9.15 10l-3.758 3.758a.767.767 0 001.085 1.084l3.757-3.758 3.758 3.758a.767.767 0 101.085-1.085L11.319 10l3.758-3.758z","fill":"#fff"}}),_c('rect',{attrs:{"x":".734","y":".5","width":"19","height":"19","rx":"9.5","stroke":"#FF5050"}})])
          )
        }
      }
    